import styled from "styled-components";

export const Div = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px auto;
  gap: 10px;
  text-align: center;
`;
